import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-add_display-click';
/**
 * Event to track when retailer has added a display to their cart.
 */
export function trackCoreCollectionsAddDisplayClick(productBasedCollectionToken, productToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productBasedCollectionToken, productToken },
    });
}
